

















































































































































































































import {Action, Getter} from 'vuex-class';
import {GetterTypes, ActionTypes} from '@/modules/neovehicle/store/types';
import {Component, Watch, Vue} from 'vue-property-decorator';
import RadioGroupList from '@/modules/neovehicle/components/radio-group-list.component.vue';
import Loading from '@/modules/neovehicle/components/loading.component.vue';
import {Market} from '@/modules/neovehicle/models/market';

import {
  Brand,
  ComponentItem,
  Family,
  FamilyGroup, FamilyVersion,
  Model,
  tabs, Tag,
  VehicleType, VehicleTypeOriginRange,
  vehicleTypes,
} from '@/modules/neovehicle/models';
import {MessageService} from '@/services/messageService';
import {CountryEnum} from '@/models/Enums';
import {GET_COUNTRY_SELECTED} from '@/store/root';
import {Unknown, VehicleTypeEnum} from '@/modules/neovehicle/models/enums';
import {uniq} from 'lodash';
import { SocialClass } from '@/modules/neovehicle/models/socialClass';

@Component({
  components: {
    RadioGroupList,
    Loading,
  },
})
export default class extends Vue {
  public Market = Market;
  public headersStep1 = [
    {text: 'Código', value: 'id', sortable: false},
    {text: 'Código Origem', value: 'idorigin', sortable: false},
    {text: 'Descrição do Modelo', value: 'name', sortable: false},
    {
      text: 'Tipo de Veículo (Fonte)',
      value: 'vehicletypeorigin.name',
      sortable: false,
    },
  ];
  public get headersStep2() {
    const headers = [
      {text: 'Código', value: 'id', sortable: false},
      {text: 'Código Origem', value: 'idorigin', sortable: false},
      {text: 'Descrição do Modelo', value: 'name', sortable: false},
      {
        text: 'Tipo de Veículo (Fonte)',
        value: 'vehicletypeorigin.name',
        sortable: false,
      },
      {
        text: 'Tipo de Veículo',
        sortable: false,
      },
      {
        text: 'Bandeira',
        sortable: false,
      },
    ];

    if (this.models.some((x) => Object.keys(x.familyversion).length)) {
      headers.push({
          text: 'Família',
          sortable: false,
        },
        {
          text: 'Família Grupo',
          sortable: false,
        },
        {
          text: 'Valor de Mercado',
          sortable: false,
        },
        {
          text: 'Data Referência do Valor',
          sortable: false,
        });
    }

    return headers;
  }

  public stepper = 1;
  public models: Model[] = [];
  public currentModels: Model[];
  public vehicleTypes = vehicleTypes;
  public vehicleTypesSelected: string[] = [];
  public brandSelected: number | null = null;
  public formStep1Valid: boolean = false;
  public formStep2Valid: boolean = false;
  public isHideAddItem: boolean = false;
  public isLoading: boolean = false;
  public tagsSelected: number[] = [];
  public socialClassSelected: number | null | undefined = null;
  public vehicleTypeEnum = VehicleTypeEnum;
  public vehicleTypeOriginRangeType = VehicleTypeOriginRange;
  public isRoadImplement: boolean;

  public familyVersionSelected: number | null = null;

  public familyGroupSelected: number | null = null;
  public familyGroups: FamilyGroup[] = [];

  public familySelected: number | null = null;
  public families: Family[] = [];

  public defaultRules: any[] = [(v: any) => !!v || 'Campo obrigatório.'];
  public vehicleTypesRules: any[] = [
    (v: any) => (v && v.length > 0) || 'Campo obrigatório.',
  ];

  @Getter(GetterTypes.GET_MODEL_CLASSIFICATION_SELECTED)
  public modelsClassification: Model[];

  @Getter(GetterTypes.GET_MODEL_EDIT_SELECTED)
  public modelsEdit: Model[];

  @Getter(GetterTypes.GET_BRANDS)
  public brands: Brand[];

  @Getter(GetterTypes.GET_FAMILY_VERSIONS)
  public familyVersions: Family[];

  @Getter(GetterTypes.GET_TAGS_BY_FAMILY_CONTEXT)
  public tagsByFamily: Tag[];

  @Getter(GetterTypes.GET_SOCIAL_CLASSES)
  public socialClasses: SocialClass[];

  @Getter(GET_COUNTRY_SELECTED)
  public countrySelected: CountryEnum;

  @Getter(GetterTypes.GET_VEHICLE_TYPE_ORIGINS_RANGE)
  public vehicleTypeOriginsRange: VehicleTypeOriginRange[];

  @Action(ActionTypes.FETCH_SOCIAL_CLASSES)
  private fetchSocialClasses: (filter: { country: CountryEnum; }) => Promise<SocialClass[]>;

  @Action(ActionTypes.FETCH_TAGS_BY_FAMILY_CONTEXT)
  private fetchTags: () => Promise<Tag[]>;

  @Action(ActionTypes.FETCH_BRANDS)
  private fetchBrands: () => Promise<Brand[]>;

  @Action(ActionTypes.FETCH_FAMILY_VERSIONS)
  private fetchFamilyVersions: (filter: {
    idBrand: number;
    idVehicleTypes: number[];
    country: CountryEnum;
  }) => Promise<Family[]>;

  @Action(ActionTypes.SAVE_MODEL_CLASSIFICATION)
  private saveClassification: (model: Model[]) => Promise<void>;

  @Action(ActionTypes.SAVE_MODEL)
  private saveModel: (models: Model[]) => Promise<void>;

  @Action(ActionTypes.UPDATE_FAMILY_VERSIONS)
  private setFamilyVersions: (familyVersions: FamilyVersion[]) => void;

  @Action(ActionTypes.UPDATE_CURRENT_TAB)
  private setCurrentTab: (selected: string) => void;

  @Action(ActionTypes.FETCH_TAGS_BY_FAMILY_VERSION)
  private fetchTagsByFamily: (filter: {idFamily: number; idFamilyVersion: number}) => Promise<Tag[]>;

  @Watch('vehicleTypesSelected')
  public onVehicleTypesSelectedChanged(value: []): void {
    const models = this.models.map((m: Model) => {
      m.vehicletypes = value.map((id: any) => ({
        id,
        name: vehicleTypes[id].name,
      }));

      return m;
    });

    this.models = models;
  }

  @Watch('brandSelected')
  public onBrandSelectedChanged(value: number): void {
    const models = this.models.map((m: Model) => {
      m.brand = this.brands.filter((x: Brand) => x.id === value)[0];
      return m;
    });

    this.models = models;

    const isUnknown = value < 0;

    if (isUnknown) {
      this.isHideAddItem = true;
      this.familyVersionSelected = Unknown;
    } else {
      this.isHideAddItem = false;
    }
  }

  @Watch('familyVersions')
  public onFamilyVersionsSelectedChanged(value: FamilyVersion[]): void {
    this.families = Array.from(
      value
        .filter((x: FamilyVersion) => x.family)
        .map((x: FamilyVersion) => x.family)
        .reduce((acc, curr) => acc.add(JSON.stringify(curr)), new Set<string>()),
    ).map((x: string) => JSON.parse(x));

    this.familyGroups = Array.from(
      value
        .filter((x: FamilyVersion) => x.family && x.family.familygroup)
        .map((x: FamilyVersion) => x.family && x.family.familygroup)
        .reduce((acc, curr) => acc.add(JSON.stringify(curr)), new Set<string>()),
    ).map((x: string) => JSON.parse(x));
  }

  public get IsLatam() {
    return this.countrySelected !== CountryEnum.Brasil;
  }

  public get brandsCombo() {
    return [
      ...this.brands
        .filter((x) => x.id === Unknown)
        .map((brand: Brand) => ({
          text: brand.name,
          value: brand.id,
        })),
      ...this.brands
        .filter((x) => x.id !== Unknown)
        .map((brand: Brand) => ({
          text: brand.name,
          value: brand.id,
        })),
    ];
  }

  public get vehicleTypesCombo() {
    return Object.keys(this.vehicleTypes).map((id: string) => ({
      text: this.vehicleTypes[id].name,
      value: id,
      icon: this.vehicleTypes[id].icon,
    }));
  }

  public handleCancel() {
    this.returnToClassificationList();
  }

  public handleBackStepper() {
    this.stepper = 1;
    this.familyVersionSelected = null;
    this.familySelected = null;
    this.familyGroupSelected = null;
  }

  public returnToClassificationList() {
    this.setCurrentTab(tabs.list);
    this.$router.push('/neovehicle/model');
  }

  public handleContinueToFamily() {
    this.stepper = 2;
    this.isLoading = true;
    this.fetchFamilyVersions({
      idBrand: Number(this.brandSelected),
      idVehicleTypes: this.vehicleTypesSelected.map((id: string) => Number(id)),
      country: this.countrySelected,
    }).then(() => {
      this.loadFamily();
    }).finally(() => {
      this.isLoading = false;
    });
  }

  public loadFamily() {
    if (
      this.currentModels.length === 1 &&
      this.currentModels[0].brand && this.brandSelected === this.currentModels[0].brand.id &&
      JSON.stringify(this.vehicleTypesSelected) ===
      JSON.stringify(this.currentModels[0].vehicletypes.map((x: VehicleType) => String(x.id))) &&
      this.currentModels[0].familyversion && this.currentModels[0].familyversion.id
    ) {
      this.familyVersionSelected = this.currentModels[0].familyversion.id;
    } else {
      this.familyVersionSelected = null;
    }
  }

  public handleAddNewFamilyVersion(item: ComponentItem) {
    this.setFamilyVersions([
      ...this.familyVersions,
      {
        id: item.id,
        name: item.name,
      },
    ]);

    this.models = this.models.map((x: Model) => ({
      ...x,
      marketvalue: item.market!.getMoneyNumber(),
      marketvaluereference: item.market!.getDateISO(),
    }));
  }

  public handleAddNewFamily(item: ComponentItem) {
    this.families = [
      ...this.families,
      {
        id: item.id,
        name: item.name,
        tags: [],
        tagsname: '',
      },
    ];
  }

  public handleChangeFamilyVersion(value: number) {
    this.familyVersionSelected = value;
    this.GetTagsByFamily({
      idFamily: 0,
      idFamilyVersion: value,
    });

    const isUnknown = value === 0;
    if (isUnknown) {
      this.formStep2Valid = false;
    }
  }

  public handleChangeFamily(value: number) {
    this.familySelected = value;
    this.GetTagsByFamily({
      idFamily: value,
      idFamilyVersion: 0,
    });
  }

  public handleDeleteNewFamilyVersion() {
    this.setFamilyVersions(this.familyVersions.filter((x: any) => x.id !== 0));
    this.familyVersionSelected = null;
    this.familySelected = null;
    this.familyGroupSelected = null;
  }

  public handleDeleteNewFamily() {
    this.families = this.families.filter((x: any) => x.id !== 0);
    this.familySelected = null;
    this.familyGroupSelected = null;
  }

  public handleDeleteNewFamilyGroup() {
    this.familyGroups = this.familyGroups.filter((x: any) => x.id !== 0);
  }

  public handleAddNewFamilyGroup(item: ComponentItem) {
    this.familyGroups = [
      ...this.familyGroups,
      {
        id: item.id,
        name: item.name,
      },
    ];
  }

  public handleSave() {
    const models: Model[] = this.models.map((m: Model) => {
      const result: Model = {
        ...m,
        vehicletypes: this.vehicleTypesSelected.map((x: string) => ({
          id: Number(x),
          name: this.vehicleTypes[x].name,
        })),
        brand: this.brands.filter((x: Brand) => x.id === this.brandSelected)[0],
        familyversion: {
          ...this.familyVersions.filter((x: FamilyVersion) => x.id === this.familyVersionSelected)[0],
        },
      };

      if (!result.familyversion.family) {
        result.familyversion = {
          ...result.familyversion,
          family: this.families.filter((x: Family) => x.id === this.familySelected)[0],
        };
      }

      if (!result.familyversion.family!.familygroup) {
        result.familyversion.family = {
          ...result.familyversion.family!,
          familygroup: this.familyGroups.filter(
            (x: FamilyGroup) => x.id === this.familyGroupSelected,
          )[0],
        };
      }

      result.familyversion.family!.tags = this.tagsSelected;
      result.familyversion.family!.idsocialclass = this.socialClassSelected;

      return result;
    });

    this.saveClassification(models)
      .then(() => {
        MessageService.Success(
          'Sucesso',
          'Operação realizada com sucesso.',
          'center',
        );
        this.returnToClassificationList();
      })
      .catch((error: any) => {
        return MessageService.Error(
          'Erro',
          'Operação não realizada.',
          'center',
        );
      });
  }

  public handleSaveModel() {
    const model: Model[] = this.models.map((m: Model) => ({
      ...m,
      vehicletypes: this.vehicleTypesSelected.map((x: string) => ({
        id: Number(x),
        name: this.vehicleTypes[x].name,
      })),
      brand: this.brands.filter((x: Brand) => x.id === this.brandSelected)[0],
    }));

    this.saveModel(model)
      .then(() => {
        MessageService.Success(
          'Sucesso',
          'Operação realizada com sucesso.',
          'center',
        );
        this.returnToClassificationList();
      })
      .catch((error: any) => {
        return MessageService.Error(
          'Erro',
          'Operação não realizada.',
          'center',
        );
      });
  }

  public created() {
    this.isLoading = true;
    this.currentModels = [...(this.modelsClassification || this.modelsEdit)];
    this.models = this.currentModels;
    this.isRoadImplement = this.currentModels.some((model: Model) => model.vehicletypes.some((vht: VehicleType) => vht.id === this.vehicleTypeEnum.RoadImplement));

    Promise.all([this.fetchBrands(), this.fetchTags(), this.fetchSocialClasses({ country: this.countrySelected })]).finally(() => {
      this.isLoading = false;

      if (this.brandSelected) {
        const models = this.models.map((m: Model) => {
          m.brand = this.brands.filter((x: Brand) => x.id === this.brandSelected)[0];
          return m;
        });
        this.models = models;
      }

      if (this.currentModels.some((model: Model) => model.familyversion && model.familyversion.family && model.familyversion.family.tags)) {
        this.tagsSelected = this.currentModels.flatMap((model: Model) => model.familyversion.family!.tags);
        this.socialClassSelected = this.currentModels[0].familyversion!.family!.idsocialclass;
      }
    });
  }

  public mounted() {
    if ((!this.modelsClassification && !this.modelsEdit)
        || (this.currentModels && !this.currentModels.length)) {
      this.$router.push('/neovehicle/model');
      return;
    }

    this.loadClassification();
  }

  private loadClassification() {
    this.brandSelected = this.currentModels.length > 1 || !this.currentModels[0].brand
      ? null
      : this.currentModels[0].brand.id;

    this.vehicleTypesSelected = this.currentModels.some((model: Model) => model.vehicletypes)
      ?  uniq(this.currentModels.flatMap((model: Model) => model.vehicletypes.map((x: VehicleType) => String(x.id))))
      : [];
  }

  private GetTagsByFamily(filter: {idFamily: number; idFamilyVersion: number}) {
    if (!filter.idFamily && !filter.idFamilyVersion) {
      return;
    }

    this.fetchTagsByFamily(filter)
      .then((tags: Tag[]) => this.tagsSelected = tags.map((tag) => tag.id))
      .catch((err) => {
        throw err;
      });
  }
}
